import {
  getRankingLastVerifiedCopy,
  getTopPick,
  RANKING_LAST_VERIFIED,
  RANKING_LAST_VERIFIED_LABEL,
} from './platformRanking';

export { getRankingLastVerifiedCopy, RANKING_LAST_VERIFIED, RANKING_LAST_VERIFIED_LABEL };

/** First entry of the overall ranking in platformRanking.ts. */
export const RANKING_TOP_PICK_SLUG = getTopPick().slug;

/** A guide card uses that guide’s own date. The shared ranking date is not copied onto a guide that already has one. */
export function guideOwnDate(date: string, reviewDate?: string): string {
  if (reviewDate && reviewDate !== RANKING_LAST_VERIFIED_LABEL) return reviewDate;
  return date;
}
